import { showMergeInfo, showTriggeredMaxItemsThresholdDuringMergeInfo } from './cart-merge';

export function init() {
  $(window).load(() => {
    const $bodyCart = $('.checkout.checkout-cart');

    const $selectQuantity = $('.product-item .dropdown-lg[data-toggle="tooltip"][show="true"]');

    if ($selectQuantity.length > 0) {
      window.displayError($selectQuantity.attr('title'), 'secondaryError', $selectQuantity.find('.bootstrap-select'));
      window.displayError($bodyCart.data('message'), 'mainError', null);
    }

    if ($bodyCart.data('isItemsNotAvailable') === true) {
      window.displayError($bodyCart.data('message'), 'mainError', null);
    } else if ($bodyCart.data('hasTriggeredMaxItemsThresholdDuringMerge') === true) {
      showTriggeredMaxItemsThresholdDuringMergeInfo();
    } else if ($bodyCart.data('isMerged') === true) {
      showMergeInfo();
    }
  });
}



// WEBPACK FOOTER //
// ./src/checkout/cart/cart.js